<template>
  <div class="product-box">
    <a
      :href="url"
      class="product-box-tiles"
      :class="{'product-box-tiles--hoverable': showOnHover}"
      v-if="!listView"
    >
      <div
        class="product-box-tiles__main-info"
      >
        <div class="product-box-tiles__slider">
          <div
            class="product-box__images-container"
            ref="imagesContainer"
          >
            <div class="product-box__images-wrapper">
              <div
                class="product-box__image"
                v-if="images.length"
                :data-img-src="images[0].src"
              >
                <img
                  class="product-box__image--image"
                  :src="images[0].src"
                  :alt="images[0].alt"
                  :title="images[0].title"
                  loading="lazy"
                  width="264"
                  height="198"
                >
                <span
                  v-if="successor"
                  class="product-box-tiles__successor-disclaimer"
                >
                  {{ $t('global.article.successor.disclaimer') }}
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="labels.length"
            class="product-box-tiles__labels"
          >
            <span
              class="product-box__label | product-label"
              :class="`product-label--${label}`"
              v-for="(label, index) in labels"
              :key="index"
            >
              {{ label }}
            </span>
          </div>
          <div
            v-if="thumbnails"
            class="product-box-tiles__image-thumbnails"
          >
            <span
              class="product-box-tiles__image-thumbnail"
              v-for="(thumbnail, index) in thumbnails"
              :key="index"
            />
          </div>
          <!-- <span
            v-if="images.length > 1"
            ref="prevSlideButton"
            class="product-box-tiles__slider-button product-box-tiles__slider-button--prev"
          />
          <span
            v-if="images.length > 1"
            ref="nextSlideButton"
            class="product-box-tiles__slider-button product-box-tiles__slider-button--next"
          /> -->
        </div>
        <span class="product-box-tiles__name">
          <span
            v-if="successor"
            class="product-box-tiles__successor-disclaimer-mobile"
          >
            {{ $t('global.article.successor.disclaimer') }}
          </span>{{ name }}
        </span>
        <span
          class="product-box-tiles__articlenumber"
          v-if="displayArticleNumber && itemId"
          v-html="$t('global.article.number_with_var.short', [itemId])"
        />
        <span
          class="product-box-tiles__quantity"
          v-if="displayQuantity && quantity"
          v-html="$t('global.amount', [quantity])"
        />
        <span
          class="product-box-tiles__brand"
          v-if="brand && brand.name"
        >
          {{ brand.name }}
        </span>

        <div class="product-box-tiles__bottom">
          <div class="product-box-tiles__utils">
            <div class="product-box-tiles__prices">
              <span
                class="product-box-tiles__price"
                :class="{
                  'product-box-tiles__price--promo': price.isRetailPrice || price.isOldPrice
                }"
              >{{ displayPriceFromPrefix ? $t('global.article.from', [price.current]) : price.current }}</span>
              <span
                v-if="price.isOldPrice"
                class="product-box-tiles__price product-box-tiles__price--old"
              >
                {{ price.old }}
              </span>
              <span
                v-else-if="price.isRetailPrice"
                class="product-box-tiles__price product-box-tiles__price--old"
              >
                {{ $t('global.rrp') }} {{ price.rrp }}
              </span>
            </div>
          </div>
          <div class="product-box-tiles__type">
            <span>{{ packagingType ? $t('global.article.per', [packagingType]) : '' }}</span>
          </div>
        </div>
      </div>
    </a>
    <div v-else-if="listView">
      <div
        class="product-box-list"
        :class="{'product-box-tiles--hoverable': showOnHover}"
      >
        <csrf-input
          ref="csrf"
        />
        <a
          :href="url"
          class="product-box-list__main"
        >
          <div class="product-box-list__slider">
            <div
              v-if="labels.length"
              class="product-box-list__labels"
            >
              <span
                class="product-box__label | product-label"
                :class="`product-label--${label}`"
                v-for="(label, index) in labels"
                :key="index"
              >
                {{ label }}
              </span>
            </div>
            <div
              class="product-box__images-container"
              ref="imagesContainer"
            >
              <a
                class="product-box__images-wrapper"
                :href="url"
              >
                <div
                  class="product-box__image"
                  :data-img-src="images[0].src"
                >
                  <img
                    class="product-box__image--image"
                    :src="images[0].src"
                    :alt="images[0].alt"
                    :title="images[0].title"
                    loading="lazy"
                    width="190"
                    height="142"
                  >
                </div>
              </a>
            </div>
            <div
              v-if="thumbnails"
              class="product-box-list__image-thumbnails"
            >
              <span
                class="product-box-list__image-thumbnail"
                v-for="(thumbnail, index) in thumbnails"
                :key="index"
              />
            </div>
          </div>
          <div
            class="product-box-list__main--info"
          >
            <span
              class="product-box-list__product-number"
            >
              <slot v-if="pageType === 'cartonsearch'">
                {{
                  $t('global.article.cartonsearch_headline', [innerLength.value, innerWidth.value, innerHeight.value, articleNumber])
                }}
              </slot>
              <slot v-else>
                {{ $t('global.article.number_with_var', [articleNumber]) }}
              </slot>
            </span>
            <a
              class="product-box-list__main--name"
              :href="url"
            >
              {{ name }}
            </a>
            <span
              class="product-box-list__main--brand"
              v-if="brand"
            >
              {{ brand.name }}
            </span>
            <div class="product-box-list__main--ratings-energy">
            </div>
            <div class="product-box-list__product-details">
              <ul>
                <li
                  v-for="(sellingPoint, index) in sellingPoints"
                  :key="index"
                >
                  {{ sellingPoint }}
                </li>
              </ul>
            </div>
          </div>
        </a>
        <div class="product-box-list__salebox">
          <a
            :href="url"
            class="product-box-list__salebox__pricelist"
          >
            <product-graduated-prices
              class="sale-box__graduated-prices"
              :graduated_prices="graduatedPrices"
              :display_string="packagingType"
              v-if="graduatedPrices.length > 1"
              :is-product-list="true"
              :url="url"
            />
            <div
              class="product-box-list__salebox__prices"
              v-else
            >
              <span
                class="product-box-list__price product-box-list__salebox__price-current"
                :class="{
                  'product-box-tiles__price--promo': price.isRetailPrice || price.isOldPrice
                }"
              >
                {{ price.current }}
              </span>
              <span
                class="product-box-list__price product-box-list__price--old"
                v-if="price.isOldPrice"
              >
                {{ price.old }}
              </span>
              <span
                class="product-box-list__price product-box-list__price--old"
                v-else-if="price.isRetailPrice"
              >
                {{ $t('global.rrp') }} {{ price.rrp }}
              </span>
            </div>
          </a>
          <div class="product-box-list__salebox__utils">
            <div class="product-box-list__salebox--mobile">
              <a
                :href="url"
                class="product-box-list__salebox__articles"
              >
                {{ itemsLength }} {{ $t('global.article.label') }}
              </a>
              <a
                class="product-box-list__salebox__button-to-article"
                :href="url"
              >
                {{ $t('global.article.button') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Commented part of a component is swiper implementation for product images.
// In order to make it work please uncomment code and replace selector `product-box-tiles__image-slide` with commented below.

// import {Swiper, Navigation} from 'swiper/dist/js/swiper.esm.js';
import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js'
import CsrfInput from '../csrfInput/csrfInput.vue'
import ProductGraduatedPrices from '../productGraduatedPrices/productGraduatedPrices'

export default {
  components: {
    CsrfInput,
    ProductGraduatedPrices
  },
  mixins: [
    globalStateComputedMixin
  ],
  props: {
    name: String,
    images: {
      type: Array,
      default() {
        return []
      }
    },
    price: {
      type: Object,
      default() {
        return {}
      }
    },
    inCart: {
      type: Boolean,
      default: null,
    },
    brand: Object,
    url: String,
    labels: {
      type: Array,
      default() {
        return []
      }
    },
    thumbnails: {
      type: Array,
      default() {
        return []
      }
    },
    variations: Array,
    graduatedPrices: {
      type: Array,
      default: () => []
    },
    packagingType: String,
    articleNumber: String,
    innerLength: Object,
    innerWidth: Object,
    innerHeight: Object,
    isProductList: Boolean,
    refreshOn: {
      type: Array,
      default() {
        return []
      }
    },
    showOnHover: {
      type: Boolean,
      default: false
    },
    displayArticleNumber: {
      type: Boolean,
      default: false
    },
    displayQuantity: {
      type: Boolean,
      default: false
    },
    displayPriceFromPrefix: {
      type: Boolean,
      default: true
    },
    quantity: Number,
    id: String,
    itemId: String,
    productId: String,
    index: Number,
    listView: Boolean,
    subCategory: false,
    itemsLength: Number,
    successor: Boolean,
  },
  computed: {
    selectableVariations() {
      return this.$store.getters['productsListPage/selectableVariations']
    },
    sellingPoints() {
      let allSellingPoints = this.$store.getters['productsListPage/sellingPoints'](this.index)
      return allSellingPoints.slice(0, 3)
    }
  },
}

</script>
